import React,{Component} from 'react'
import axios from 'axios';
import { APIURL } from '../../../config/config';
import NumberFormat from 'react-number-format'

class CarLeasingViewPercent extends Component {
  constructor (props){
    super(props)
    this.state = {
      lists: [],
      car_id : this.props.car.car_id,
      leasingName: ['SCB', 'GE', 'TA', 'KK', 'BA'],
      leasingPercents: [
        {percent_id: 7, percent_name: '120%', percent_value: 120},
        {percent_id: 1, percent_name: '110%', percent_value: 110},
        {percent_id: 2, percent_name: '95%', percent_value: 95},
        {percent_id: 3, percent_name: '90%', percent_value: 90},
        {percent_id: 4, percent_name: '85%', percent_value: 85},
        {percent_id: 5, percent_name: '80%', percent_value: 80},
        {percent_id: 6, percent_name: '75%', percent_value: 75},
      ]
    }
    this.handlePercentInput = this.handlePercentInput.bind(this);
    this.calCarLeasing = this.calCarLeasing.bind(this);
  }

  componentDidMount() {
    this.loadCarLeasing();
  }

  componentWillReceiveProps(nextProps) {

     if(nextProps.carLeasingList.length > 0){
       // console.log('===nextProps car_id=' + nextProps.car.car_id)
        if(nextProps.carLeasingList[0].car_id === nextProps.car.car_id){
          const carLeasingList = nextProps.carLeasingList;
          this.calCarLeasing(carLeasingList)
        }
     }

      if(nextProps.car !== this.props.car) {
      this.setState({
        car_id: nextProps.car.car_id
      },()=>{
        this.loadCarLeasing();
      });

    }

  }

  loadCarLeasing() {
    //console.log('===loadCarLeasing car_id=' + this.state.car_id)
    var uri =  APIURL + '/car_leasing/'+this.state.car_id;
    axios.get(uri)
      .then(res => {
      const carLeasingList = res.data;
      this.calCarLeasing(carLeasingList)
      }).catch(error => {
      this.setState({lists: []})
    })
  }

  calCarLeasing(carLeasingList) {
    const carLeasingLists = carLeasingList.map(leasing => {
      const car_leasing_name = leasing.car_leasing_name;
      let car_leasing_price_median = 0;
      // if(car_leasing_name === 'SCB'){
        // || car_leasing_name === 'KK' แจ้งเอาออก 2021-03-09
        // (car_leasing_name === 'SCB' เอาออก 2023-03-03
        // car_leasing_price_median = leasing.car_leasing_price_median*(110/100)
      if(car_leasing_name === 'OAT') {
        car_leasing_price_median = leasing.car_leasing_price_median*(120/100)
      } else {
        car_leasing_price_median = leasing.car_leasing_price_median
      }
      // const car_leasing_price_median = leasing.car_leasing_price_median;
      const percent = 90
      const price_median = parseInt(car_leasing_price_median, 10) * (percent/100)
      return {...leasing, ...{percent: percent, price_median: parseInt(price_median, 10)}}
    })
    this.setState({lists: carLeasingLists})
  }

  handlePercentInput(event, leasingIndex) {
    const {lists} = this.state;
    let targetName = event.target.name;
    let percentNew = Number(event.target.value);

    // leasingPercent_SCB
    // console.log('targetName: ', targetName)
    const carLeasing = lists[leasingIndex];
    // let car_leasing_price_median = 0;
    // || targetName === 'leasingPercent_KK'
    // OAT
    //   if (targetName === 'leasingPercent_SCB') {
    //       car_leasing_price_median = carLeasing.car_leasing_price_median*(110/100)

    /* if (targetName === 'leasingPercent_OAT' && percentNew < 100) {
      car_leasing_price_median = carLeasing.car_leasing_price_median*(120/100)
    } else {
      car_leasing_price_median = carLeasing.car_leasing_price_median
    } */

    let car_leasing_price_median = carLeasing.car_leasing_price_median
    carLeasing.percent = percentNew
    const price_median = parseInt(car_leasing_price_median, 10) * (percentNew/100)
    carLeasing.price_median = parseInt(price_median, 10)

    lists[leasingIndex] = carLeasing

    this.setState({lists: lists})
  }

  render(){
    if(this.state.lists.length === 0){
      let trLeasing = this.state.leasingName.map((leasing, index) => {
        return (
          <tr key={index}>
            <td style={{width: 100}}>{leasing}</td>
            <td style={{width: 100}}>&nbsp;-&nbsp;</td>
            <td style={{width: 100}}>&nbsp;-&nbsp;</td>
            <td style={{width: 100}}>&nbsp;-&nbsp;</td>
          </tr>
        )
      })
      return (
        <div>
          <table className="tableWhitesmoke" style={{marginTop: 8}}>
            <tbody>
             {trLeasing}
            </tbody>
          </table>
        </div>
      )
    }else {
      let trLeasing = this.state.lists.map((leasing, index) => {
        // if(leasing.car_leasing_name!=='MPRICE') {
        const car_leasing_name = leasing.car_leasing_name
        const percent = leasing.percent
        let leasingPercentSelect = (
          <select className="form-control"
                  name={'leasingPercent_'+car_leasing_name}
                  onChange={(event) => this.handlePercentInput(event, index)}
                  value={percent}
          >
            {this.state.leasingPercents.map(leasingPercent => {
              // console.log('leasingPercent.percent_value: ',typeof leasingPercent.percent_value, leasingPercent.percent_value)
              // console.log('leasingPricePercent: ',typeof leasingPricePercent, leasingPricePercent)
              /*if(leasingPercent.percent_value === percent){
                return (
                  <option key={leasingPercent.percent_id}
                          value={leasingPercent.percent_value}
                          selected="selected"
                  >
                    {leasingPercent.percent_name}
                  </option>
                )
              }else{
                return (
                  <option key={leasingPercent.percent_id}
                          value={leasingPercent.percent_value}
                  >
                    {leasingPercent.percent_name}
                  </option>
                )
              }*/
              return (
                <option key={leasingPercent.percent_id}
                        value={leasingPercent.percent_value}
                >
                  {leasingPercent.percent_name}
                </option>
              )

            })}
          </select>
        )

          return (
            <tr key={index}>
              <td style={{width: 100}}>{leasing.car_leasing_name}</td>
              <td style={{width: 100}}>
                <NumberFormat
                  value={leasing.car_leasing_price_median} displayType={'text'} thousandSeparator={true}
                  prefix={'฿'}/>
              </td>
              <td style={{width: 100}} className="text-center">

                {/*<NumberFormat
                  value={leasing.car_leasing_price} displayType={'text'} thousandSeparator={true}
                  prefix={'฿'}/> {leasing.percent}% */}

                {leasingPercentSelect}
              </td>
              <td style={{width: 100}} className="text-center">
                <div className="badge-success text-white">
                  <strong>
                  <NumberFormat
                    value={leasing.price_median} displayType={'text'} thousandSeparator={true}
                    prefix={'฿'}/>
                  </strong>
                </div>
              </td>
            </tr>
          )
        //}else{
          /*return (
          <tr key={index}>
            <td style={{width: 100}}>ราคากลาง</td>
            <td colSpan={2} style={{width: 200}} className="text-center">
              <NumberFormat
                value={leasing.car_leasing_price} displayType={'text'} thousandSeparator={true}
                prefix={'฿'}/>
            </td>
          </tr>
          )*/
        //}
      })

      return (
        <div>
          <table className="tableWhitesmoke" style={{marginTop: 8}}>
            <thead>
              <tr>
              <th>ธนาคาร</th>
              <th>ราคากลาง</th>
              <th className="text-center">เปอร์เซ็นต์</th>
              <th className="text-center">ยอดจัด</th>
              </tr>
            </thead>
            <tbody>
            {trLeasing}
            </tbody>
          </table>
        </div>
      )
    }
  }
}

/*const styles = {
  tableLeasing: {
    backgroundColor: 'tableWhitesmoke'
  }
}*/

export default CarLeasingViewPercent ;
